module.exports = __webpack_public_path__ + "static/media/profile-5.0e027990.png";